import Player from '@vimeo/player';
window.VimeoPlayer = Player;
